<div [formGroup]="finishTourForm" class="form flex flex-col">
  {{commandTemplate?.flow?.settings?.customFlowSettings?.message}}
  <div class="text-base mt-3">Startzeit: {{tour?.actualDepartureDateTime | date:'dd.MM.yyyy HH:mm'}}</div>
  <div class="p-field">
    <label for="range">{{commandTemplate?.flow?.settings?.customFlowSettings?.['form.actualArrivalDateTime.label']}}</label><br/>
    
    <!-- we set a negative tab index here to prevent the field from autofocus -->
    <p-calendar
      [style]="{'width':'100%'}"
      formControlName="actualArrivalDateTime"
      id="fromDate"
      dateFormat="dd.mm.yy"
      [minDate]="getMinDateTime()" 
      [showTime]="true"
      hourFormat="24"
      [tabindex]="-1"
      [placeholder]="commandTemplate?.flow?.settings?.customFlowSettings?.['form.actualArrivalDateTime.placeholder']"
      appendTo="body"
      [autofocus]="false"
      [showClear]="true">
    </p-calendar>
  </div>

</div>
